export default function WhatIsLeadership() {
  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 mb-4">
          Лидерство — это не должность
        </h2>
        <p className="text-base md:text-lg text-gray-600 mb-10 max-w-3xl leading-relaxed">
          Руководитель может иметь должность, полномочия и право принимать решения, но при этом не быть лидером для своей команды. Формальная власть даёт право требовать. Управленческое влияние даёт возможность вести за собой.
        </p>

        <div className="grid md:grid-cols-2 gap-6 mb-10">
          <div className="bg-gray-50 rounded-xl border border-gray-200 p-6 md:p-8">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 rounded-full bg-gray-200 flex items-center justify-center flex-shrink-0">
                <i className="ri-shield-user-line text-gray-600 text-lg"></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900">Формальная власть</h3>
            </div>
            <ul className="space-y-2.5 text-sm text-gray-600">
              <li className="flex items-start gap-2"><i className="ri-close-circle-line text-red-500 mt-0.5 flex-shrink-0"></i> Должностные полномочия</li>
              <li className="flex items-start gap-2"><i className="ri-close-circle-line text-red-500 mt-0.5 flex-shrink-0"></i> Право ставить задачи</li>
              <li className="flex items-start gap-2"><i className="ri-close-circle-line text-red-500 mt-0.5 flex-shrink-0"></i> Контроль через иерархию</li>
              <li className="flex items-start gap-2"><i className="ri-close-circle-line text-red-500 mt-0.5 flex-shrink-0"></i> Сотрудники выполняют «потому что должны»</li>
            </ul>
          </div>
          <div className="bg-teal-50 rounded-xl border border-teal-200 p-6 md:p-8">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 rounded-full bg-teal-100 flex items-center justify-center flex-shrink-0">
                <i className="ri-star-line text-teal-700 text-lg"></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900">Управленческое влияние</h3>
            </div>
            <ul className="space-y-2.5 text-sm text-gray-700">
              <li className="flex items-start gap-2"><i className="ri-checkbox-circle-line text-teal-600 mt-0.5 flex-shrink-0"></i> Доверие команды</li>
              <li className="flex items-start gap-2"><i className="ri-checkbox-circle-line text-teal-600 mt-0.5 flex-shrink-0"></i> Понятные цели и смысл работы</li>
              <li className="flex items-start gap-2"><i className="ri-checkbox-circle-line text-teal-600 mt-0.5 flex-shrink-0"></i> Самостоятельность сотрудников</li>
              <li className="flex items-start gap-2"><i className="ri-checkbox-circle-line text-teal-600 mt-0.5 flex-shrink-0"></i> Сотрудники действуют «потому что хотят»</li>
            </ul>
          </div>
        </div>

        <p className="text-base text-gray-700 leading-relaxed mb-8 max-w-3xl">
          Практическое лидерство проявляется в способности руководителя формировать доверие, объяснять цели, влиять на поведение сотрудников, принимать решения, брать ответственность, давать обратную связь, создавать самостоятельность, развивать сотрудников, проходить через конфликты и вести команду через изменения.
        </p>

        <div className="flex flex-wrap gap-3">
          {['Формировать доверие', 'Объяснять цели', 'Влиять на поведение', 'Принимать решения', 'Брать ответственность', 'Давать обратную связь', 'Создавать самостоятельность', 'Развивать сотрудников', 'Проходить через конфликты', 'Вести через изменения'].map((item) => (
            <span key={item} className="bg-gray-100 border border-gray-200 text-gray-700 px-3 py-1.5 rounded-full text-xs font-medium">
              {item}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}